<template>
  <!-- 简历 -->
  <div class="detail__wrap" v-show="visible">
    <div class="flex fdsdcvcx">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item @click.native="toggle(false)"
          >首页</el-breadcrumb-item
        >
        <el-breadcrumb-item @click.native="toggle(false)"
          >话题管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>查看详情</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button type="text" @click="getDetail({ id: info.id })"
        >刷新</el-button
      >
    </div>

    <!-- 表格 -->
    <div class="section shadow jianli">
      <div class="sck">
        <el-button
          class="backBtn"
          plain
          icon="el-icon-d-arrow-left"
          @click="toggle(false)"
          size="mini"
          >返回</el-button
        >
      </div>
      <div class="main">
        <div class="h5">
          <div class="title">{{ info.title }}</div>
          <div class="time2">{{ info.create_time }} 发布</div>
          <div v-html="info.desc"></div>
          <el-image
            v-for="(item, index) in info.images"
            :key="index"
            style="width: 100px; height: 100px; margin: 10px"
            :src="item"
            :preview-src-list="info.images"
          >
          </el-image>
        </div>

        <div class="flex bgd">
          <div class="flex vdz">
            <i class="el-icon-view"></i>
            <span class="mjk">{{ info.view_num }}</span>
          </div>
          <div class="flex vdz">
            <i class="icon3"></i><span class="mjk">{{ info.like_num }}</span>
          </div>
          <div class="flex vdz">
            <i class="el-icon-share"></i
            ><span class="mjk">{{ info.share_num }}</span>
          </div>
          <div class="flex vdz">
            <i class="icon2"></i><span class="mjk">{{ info.comment_num }}</span>
          </div>
        </div>

        <div v-for="(item, index) in info.comments" :key="item.id">
          <div class="">
            <div class="lflex">
              <div v-if="item.type == 2">
                <img class="img" src="~@/assets/img/cxa.png" alt="" />
              </div>
              <div v-else>
                <img class="img" v-if="item.avatar" :src="item.avatar" alt="" />
                <div v-else class="tan">
                  {{ item.nickname ? item.nickname.slice(-1) : "" }}
                </div>
              </div>
              <div class="lflex1">
                <div class="nickname">
                  <div :class="{ typename: item.type == 2 }">
                    {{ item.type == 1 ? item.nickname : "作者" }}
                  </div>
                  <div class="time">{{ formatDateTime(item.create_time) }}</div>
                </div>
                <div class="lt">
                  <el-button
                    type="text"
                    class="delBtn"
                    @click="deleteComment(item, index, info.comments)"
                    >删除</el-button
                  >
                  <el-button
                    @click="setreplycomment"
                    v-show="reply_comment_id === item.id"
                    type="text"
                    >取消回复</el-button
                  >
                  <el-button
                    @click="setindex(item)"
                    v-show="reply_comment_id !== item.id"
                    type="text"
                    >回复</el-button
                  >
                </div>
              </div>
            </div>
            <div class="content">{{ item.content }}</div>
            <div v-for="(i, n) in item.reply_comments" :key="i.id">
              <div class="rmain">
                <div class="lflex">
                  <div v-if="i.type == 2">
                    <img class="img1" src="~@/assets/img/cxa.png" alt="" />
                  </div>
                  <div v-else>
                    <img class="img1" v-if="i.avatar" :src="i.avatar" alt="" />
                    <div v-else class="tan1">
                      {{ i.nickname ? i.nickname.slice(-1) : "" }}
                    </div>
                  </div>

                  <div class="lflex1">
                    <div class="nickname1 flex">
                      <div :class="{ typename: i.type == 2 }">
                        {{ i.type == 1 ? i.nickname : "作者" }}
                      </div>

                      <span v-if="i.reply_nickname || i.reply_type == 2">
                        回复
                        {{
                          i.reply_type == 1 ? i.reply_nickname : "作者"
                        }}</span
                      >
                      <span class="time1">{{
                        formatDateTime(i.create_time)
                      }}</span>
                    </div>

                    <div class="lt">
                      <el-button
                        type="text"
                        class="delBtn"
                        @click="deleteComment(i, n, item.reply_comments)"
                        >删除</el-button
                      >
                      <el-button
                        type="text"
                        @click="setreplycomment"
                        v-show="reply_comment_id === i.id"
                        >取消回复</el-button
                      >
                      <el-button
                        type="text"
                        @click="setindex(i)"
                        v-show="reply_comment_id !== i.id"
                        >回复</el-button
                      >
                    </div>
                  </div>
                </div>
                <div class="content">{{ i.content }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="sck1">
          <el-input
            ref="elinput"
            :placeholder="
              reply_comment_id
                ? `@${type == 2 ? '作者' : nickname}`
                : '我来说两句'
            "
            v-model="content"
            @keyup.enter.native="sendcomment"
          >
            <!-- <div slot="prepend">{{reply_comment_id ? :'评论'}}</div> -->
            <el-button slot="append" type="primary" @click="sendcomment"
              >发送</el-button
            >
          </el-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      info: {
        title: "",
        desc: "",
        images: [],
        create_time: "",
        comments: [],
        view_num: 0,
        like_num: 0,
        share_num: 0,
        comment_num: 0,
      },
      content: "",
      reply_comment_id: 0,
      nickname: "",
      type: 0,
    };
  },
  methods: {
    getDetail(row) {
      this.visible = true;
      this.reply_comment_id = 0;
      this.nickname = "";
      this.$http
        .get("/admin/topic/info", { params: { id: row.id } })
        .then((res) => {
          if (res.code === 1) {
            this.info = res.data;
            this.$emit("getDetail");
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    toggle() {
      this.visible = false;
    },
    formatDateTime(inputTime) {
      const inputDate = new Date(inputTime);
      const currentDate = new Date();

      // 比较年月日
      const isSameDay =
        inputDate.getFullYear() === currentDate.getFullYear() &&
        inputDate.getMonth() === currentDate.getMonth() &&
        inputDate.getDate() === currentDate.getDate();

      if (isSameDay) {
        // 当天显示时分
        const hours = inputDate.getHours().toString().padStart(2, "0");
        const minutes = inputDate.getMinutes().toString().padStart(2, "0");
        return `${hours}:${minutes}`;
      } else {
        return inputTime;
      }
    },
    sendcomment() {
      if (!this.content) return this.$message.error("请输入内容");
      this.$http
        .post("/admin/topic/comment", {
          topic_id: this.info.id,
          content: this.content,
          reply_comment_id: this.reply_comment_id,
        })
        .then((res) => {
          if (res.code === 1) {
            this.$message.success("发送成功");
            this.content = "";

            this.getDetail(this.info);
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    setreplycomment() {
      this.reply_comment_id = 0;
    },
    setindex(item) {
      this.reply_comment_id = item.id;
      this.nickname = item.nickname;
      this.type = item.type;
      this.focus = true;
      this.$refs.elinput.focus();
    },
    deleteComment(item, index, arr) {
      console.log(item, index);
      this.$confirm("确认删除评论吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.$http
            .post("/admin/topic/deleteComment", {
              topic_id: this.info.id,
              id: item.id,
            })
            .then((res) => {
              if (res.code === 1) {
                this.$message.success("删除成功");
                arr.splice(index, 1);
                this.$emit("getDetail");
                this.info.comment_num -= 1;
              } else {
                this.$message.error(res.msg);
              }
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
.detail__wrap {
  background-color: #f5f5f5;
  padding: 0 20px 20px;
  z-index: 999 !important;
  overflow-y: scroll;
  @include position($t: 0, $r: 0, $b: 0, $l: 0);

  .crumbs__wrap {
    margin-bottom: 20px;
  }
}

.flex {
  display: flex;
}
.mt50 {
  margin-top: 50px;
}
.fs16 {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.main {
  background-color: #fff;
  padding: 20px;
  width: 750px;
  margin: auto;
}
.jianli {
  background-color: #fff;
  padding: 0 20px 20px;
  .title {
    font-size: 20px;
    text-align: center;
    padding: 10px;
  }
}
.icon2 {
  -webkit-mask-image: url(~@/assets/img/2.svg);
  mask-image: url(~@/assets/img/2.svg);
  background-color: #000;
  width: 16px;
  height: 16px;
  display: inline-block;
}
.icon3 {
  -webkit-mask-image: url(~@/assets/img/3.svg);
  mask-image: url(~@/assets/img/3.svg);
  background-color: #000;
  width: 16px;
  height: 16px;
  display: inline-block;
}
.bgd {
  padding: 10px 0;
  border-top: 1px solid #f5f5f5;
  margin: 10px 0;
}
.vdz {
  margin-right: 20px;
  align-items: center;
  font-size: 14px;
  color: #333;
}
.mjk {
  margin-left: 5px;
}
.lflex {
  display: flex;
  align-items: center;
  flex: 1;
  margin: 10px 0 0;
}
.jus {
  justify-content: space-between;
}
.img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin: 0 10px 0 0;
}
.tan {
  background: #0476fc;
  width: 40px;
  height: 40px;
  margin: 0 10px 0 0;
  border-radius: 50%;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.img1 {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin: 0 10px 0 0;
}
.tan1 {
  background: #0476fc;
  width: 30px;
  height: 30px;
  margin: 0 10px 0 0;
  border-radius: 50%;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.lflex1 {
  flex: 1;
  justify-content: space-between;
  display: flex;
  align-items: center;
}
.time {
  color: #999999;
  font-size: 12px;
  margin: 5px 0 0;
}
.time1 {
  color: #999999;
  font-size: 12px;
  margin: 0 0 0 5px;
}
.time2 {
  color: #999999;
  font-size: 12px;
  text-align: center;
}
.lt {
  display: flex;
  justify-content: flex-end;
}
.nickname {
  font-size: 14px;
}
.nickname1 {
  font-size: 12px;
}
.content {
  font-size: 14px;
  padding: 10px;
}
.rmain {
  padding: 0 0 0 20px;
}
.typename {
  background: #fa6060;
  color: #fff;
  width: 30px;
  text-align: center;
  margin: 0 5px 0 0;
}
.sck {
  position: sticky;
  top: -20px;
  background: #fff;
  z-index: 1;
  padding: 20px 0;
}
.bgd {
  position: sticky;
  background: #fff;
  bottom: 30px;
}
.sck1 {
  position: sticky;
  background: #fff;
  bottom: -20px;
  padding: 10px 0;
}
.h5 {
  width: 750px;
  margin: auto;
  overflow: auto;
}
.fdsdcvcx {
  align-items: center;
  justify-content: space-between;
}
</style>